import { RequestPost } from '../apiClient/api/RequestService';

function logoutStart(){
    return {type : "LOGOUT"}
}
function logoutSuccess(){
    return {type : "LOGOUT_SUCCESS"}
}

export function logout(access_token, refresh_token){
    const content = {
        access_token,
        refresh_token
    }
    return async dispatch => {
        dispatch(logoutStart())
        await RequestPost('/v1/account/logout', content)

        dispatch(logoutSuccess())
    }
}
